import useCategories from 'coreHooks/categories/useCategories';
import useCategory from 'coreHooks/categories/useCategory';

export default (categoryResult: ReturnType<typeof useCategory>) => {
	const subCategories = categoryResult?.category?.categories || [];

	return useCategories(subCategories);
};